import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { ARVI, waLink, DEFAULT_WA_MESSAGE } from "../../lib/arvi";

const NAV = [
  { label: "The Legacy", href: "#legacy" },
  { label: "Collections", href: "#collections" },
  { label: "Craft", href: "#craft" },
  { label: "Design", href: "#design" },
  { label: "Investment", href: "#pricing" },
  { label: "Commission", href: "#process" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
        scrolled
          ? "bg-ivory/90 backdrop-blur-md border-b border-[hsl(var(--gold)/0.25)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="header-logo"
          className="font-display text-2xl md:text-[28px] tracking-[0.25em] text-maroon"
        >
          {ARVI.brand}
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-overline text-maroon/80 hover:text-gold transition-colors duration-300"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={waLink(DEFAULT_WA_MESSAGE)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-whatsapp-cta"
            className="hidden md:inline-flex btn-cta-base btn-wa"
          >
            Enquire on WhatsApp
          </a>
          <button
            type="button"
            aria-label="Toggle menu"
            data-testid="header-menu-toggle"
            onClick={() => setOpen((s) => !s)}
            className="lg:hidden p-2 text-maroon"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-nav-panel"
          className="lg:hidden bg-ivory border-t border-[hsl(var(--gold)/0.25)]"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-overline text-maroon"
              >
                {item.label}
              </a>
            ))}
            <a
              href={waLink(DEFAULT_WA_MESSAGE)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-whatsapp-cta"
              className="mt-2 btn-cta-base btn-wa"
            >
              Enquire on WhatsApp
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
